import type { TypedCreditBalance } from '@/lib/credits-api'
import { formatWeeklySubscriptionCredits, hasWeeklySubscriptionCredits } from '@/lib/credit-balances'
import { formatCredits } from '@/lib/subscriptions'
import { cn } from '@/lib/utils'

type TypedCreditListProps = {
  balances: TypedCreditBalance[] | undefined
  showSubscription?: boolean
  className?: string
}

export function TypedCreditList({ balances, showSubscription = false, className }: TypedCreditListProps) {
  if (!balances?.length) return null

  return (
    <dl className={cn('space-y-1.5 text-sm', className)}>
      {balances.map((balance) => (
        <div key={balance.credit_type_id} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5">
          <dt className="text-muted-foreground">{balance.credit_name}</dt>
          <dd className="text-right font-semibold text-foreground">
            {formatCredits(Number(balance.available_balance_credits ?? 0))}
            {showSubscription && hasWeeklySubscriptionCredits(balance) && (
              <span className="ml-2 font-normal text-muted-foreground">
                + {formatWeeklySubscriptionCredits(balance)} diese Woche
              </span>
            )}
          </dd>
        </div>
      ))}
    </dl>
  )
}
